module.exports = __webpack_public_path__ + "media/images/game/footer-guy-dark-eade222c9bc87de30128b8b7b445b7b7.png";